import type { MaybeRefOrGetter } from 'vue'

type Query = Record<string, string | number | undefined>

// API routes answer { success, data | message }; these unwrap that and throw the message on failure

// Loads data for a page. Refetches when the url or query changes, and forwards the session cookie during SSR.
export const useApiData = <T>(url: MaybeRefOrGetter<string>, query?: MaybeRefOrGetter<Query>) => {
    const requestFetch = useRequestFetch()
    return useAsyncData(
            () => `${ toValue(url) }?${ JSON.stringify(toValue(query) ?? {}) }`,
            async () => {
                const response = await requestFetch<ApiResponse<T>>(toValue(url), { query: toValue(query) })
                if (!response.success) throw new Error(response.message)
                return response.data
            },
    )
}

// For actions in the browser (saving, deleting, loading more)
export const apiRequest = async <T>(method: 'GET' | 'POST' | 'PATCH' | 'DELETE', url: string, body?: object, query?: Query): Promise<T> => {
    const response = await $fetch<ApiResponse<T>>(url, { method, body, query })
    if (!response.success) throw new Error(response.message)
    return response.data
}
